import { MODULE } from '@core/configs';
import { environment } from '@environments/environment';

export const APP_CONFIG = {
  module: MODULE.liveConsole,
  apiBaseUrl: environment.apiBaseUrl,
  tokenUrl: environment.tokenUrl,
  inActiveTime: 30,
};
